firebird.factory('loginAPIService', [
    '$window',
    '$q',
    '$resource',
    'helperService',
    function ($window, $q, $resource, helperService) {
        var endpoint = helperService.getAPIUrl() + '/IVYaJLSOFiVPmLohXOqdnbhxuNuLNLtvHTXSEQGj';

        var service = {
            login: login,
            checkUserType: checkUserType,
            getSTSToken: getSTSToken
        };

        return service;

        ////////////////////////

        function login(param) {
            var deferred = $q.defer();
            $resource(endpoint)
                .save(param)
                .$promise.then(
                    function (token) {
                        deferred.resolve(token);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not login.');
                    }
                );

            return deferred.promise;
        }

        function getSTSToken(param) {
            var deferred = $q.defer();

            var options = {
                method: 'post',
                data: { Login: param.Login, Password: param.Password }
            };

            $window.cordova.plugin.http.sendRequest(
                param.tokenEndPoint,
                options,
                function (response) {
                    var token = JSON.parse(response.data);
                    deferred.resolve(token);
                },
                function (response) {
                    deferred.reject(response.error + ' - Could not retrieve sts token.');
                }
            );

            return deferred.promise;
        }

        function checkUserType(param) {
            var deferred = $q.defer();

            $resource(endpoint + '/type')
                .save(param)
                .$promise.then(
                    function (userType) {
                        deferred.resolve(userType.message);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not retrieve userType.');
                    }
                );

            return deferred.promise;
        }
    }
]);
